export const CURRENT_PROJECT = "mci-project-cookie";
export const DISABLE_QUERY_POLLING = "disable-query-polling";
export const DISABLE_TASK_REVIEW = "disable-task-review";
export const getNotificationTriggerCookie = (type: string) =>
  `${type}-notification-trigger`;
export const HIDE_FEEDBACK = "HIDE_FEEDBACK";
export const INCLUDE_COMMIT_QUEUE_PROJECT_PATCHES =
  "include-commit-queue-project-patches";
export const INCLUDE_HIDDEN_PATCHES = "include-hidden-patches";
export const INCLUDE_NEVER_ACTIVATED_TASKS = "include-never-activated-tasks";
export const SLACK_NOTIFICATION_BANNER = "has-closed-slack-banner";
export const SUBSCRIPTION_METHOD = "subscription-method";
export const SEEN_DEBUG_SPAWN_HOST_GUIDE_CUE =
  "seen-debug-spawn-host-guide-cue";
export const SEEN_WATERFALL_ONBOARDING_TUTORIAL =
  "seen-waterfall-onboarding-tutorial";
export const SEEN_TASK_HISTORY_ONBOARDING_TUTORIAL =
  "seen-task-history-onboarding-tutorial";
export const TASK_HISTORY_INACTIVE_COMMITS_VIEW =
  "task-history-inactive-commits-view";
export const SEEN_TASK_REVIEW_TOOLTIP = "seen-task-review-tooltip";
export const SEEN_TEST_SELECTION_GUIDE_CUE = "seen-test-selection-guide-cue";
export const SEEN_GITHUB_NAV_GUIDE_CUE = "seen-github-nav-guide-cue";
export const OMIT_INACTIVE_WATERFALL_BUILDS = "omit-inactive-waterfall-builds";
